module.exports = __webpack_public_path__ + "img/LittleandLarge-compressor_tn.42e14572.jpg";